import { Observable } from 'rxjs';

export interface SpokeMst {
  id?: any;
  spokeId?: any;
  hubId: any;
  divisionId: any;
  divisionName?: string;
  districtId: any;
  districtName?: string;
  stateId: any;
  stateName?: string;
  spokeName: string;
  spokeTypeId: any;
  displayName?: string;
  registrationNo?: string;
  contactNumber?: string;
  email?: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  cityAreaId?: any;
  pincode?: string;
  printHeaderText?: string;
  restrictFlag: boolean;
  isActive: boolean;
  createdBy?: number;
}

export abstract class SpokeMstData {
  abstract list(url: string): Observable<any>;
  abstract getById(url: string): Observable<SpokeMst>;
  abstract create(url: string, data: SpokeMst): Observable<any>;
  abstract update(url: string, data: SpokeMst): Observable<any>;
}
